<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.745"
    height="11.641"
    viewBox="0 0 17.745 11.641">
    <g id="Vrstva_559" data-name="Vrstva 559" transform="translate(-3.075 -6.159)">
      <line
        id="Line_57"
        data-name="Line 57"
        x1="16.14"
        transform="translate(3.93 12)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
      <path
        id="Path_47"
        data-name="Path 47"
        d="M8.33,7.22,4.22,11.33a1,1,0,0,0,0,1.41l4,4"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
    </g>
  </svg>
</template>
